import React from 'react';
import {Link} from 'react-router-dom';
import {ArrowUpRight} from 'lucide-react';
import '../styles/operational-links.css';

// Keep native link behaviour, including modified clicks and opening a new tab.
const OperationalLink = React.forwardRef(function OperationalLink(
  {icon: Icon = ArrowUpRight, children, className = '', ...props}, ref
) {
  return <Link ref={ref} className={`operational-link ${className}`} {...props}>
    <Icon className="operational-link__icon" aria-hidden="true" focusable="false" />
    <span className="operational-link__label">{children}</span>
  </Link>;
});

export default OperationalLink;
